// Profil d'un fournisseur, saisi dans son formulaire d'inscription : ce qu'il vend, où il livre, à quelles conditions.
// Partagé entre le formulaire public (src/components/Public/ClientRegistrationForm.tsx) et le serveur (functions/api/[[path]].js).
// Il sert ensuite à présenter le fournisseur aux bons clients (vitrine) : les catégories viennent d'une liste fermée pour que le tri par métier reste fiable.

export const CATEGORIES_FOURNISSEUR = ['Hygiène et entretien', 'Alimentaire', 'Boissons', 'Coiffure', 'Onglerie', 'Hôtellerie', 'Emballages'];
export const JOURS_LIVRAISON = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

// `autre` : ce que le fournisseur vend quand ça ne rentre dans aucune catégorie (texte libre, relu par le super admin).
export const AUTRE_MAX = 120;
export const PROFIL_FOURNISSEUR_VIDE = { categories: [], autre: '', zone: '', minimum_ht: null, jours_livraison: [], delai_heures: null };

const texte = (v, max) => String(v == null ? '' : v).trim().slice(0, max);

/**
 * Ramène ce que le navigateur envoie à un profil valide, ou renvoie { erreur }.
 * Il faut au moins une catégorie, ou un texte « autre » ; le reste est facultatif.
 */
export const profilFournisseurValide = (brut) => {
    const b = brut && typeof brut === 'object' ? brut : {};
    const categories = [...new Set(Array.isArray(b.categories) ? b.categories : [])];
    const autre = texte(b.autre, AUTRE_MAX);
    if (categories.length === 0 && !autre) return { erreur: 'Indiquez ce que vous vendez : au moins une catégorie, ou « Autre » avec quelques mots.' };
    if (categories.some((c) => !CATEGORIES_FOURNISSEUR.includes(c))) return { erreur: 'Catégorie de produits inconnue.' };
    const jours = [...new Set(Array.isArray(b.jours_livraison) ? b.jours_livraison : [])];
    if (jours.some((j) => !JOURS_LIVRAISON.includes(j))) return { erreur: 'Jour de livraison inconnu.' };
    let minimum = null;
    if (b.minimum_ht !== '' && b.minimum_ht != null) {
        minimum = Math.round(Number(b.minimum_ht) * 100) / 100;
        if (!Number.isFinite(minimum) || minimum < 0 || minimum > 100000) return { erreur: 'Le minimum de commande doit être un montant en euros, de 0 à 100 000.' };
    }
    let delai = null;
    if (b.delai_heures !== '' && b.delai_heures != null) {
        delai = Math.round(Number(b.delai_heures));
        if (!Number.isFinite(delai) || delai < 0 || delai > 720) return { erreur: 'Le délai de préparation va de 0 à 720 heures.' };
    }
    return {
        profil: {
            categories: CATEGORIES_FOURNISSEUR.filter((c) => categories.includes(c)),
            autre,
            zone: texte(b.zone, 200),
            minimum_ht: minimum,
            jours_livraison: JOURS_LIVRAISON.filter((j) => jours.includes(j)),
            delai_heures: delai,
        },
    };
};

/** Relit un profil stocké (JSON) sans jamais échouer : vide ou abîmé = profil vide. */
export const profilFournisseurLu = (texteJson) => {
    try {
        const v = JSON.parse(texteJson || '{}');
        const r = profilFournisseurValide(v);
        if (r.profil) return { ...r.profil, ...(v.recommande_par ? { recommande_par: String(v.recommande_par) } : {}) };
    } catch (e) { /* profil abîmé : on l'ignore */ }
    return { ...PROFIL_FOURNISSEUR_VIDE };
};
